import { Button } from "@material-ui/core";
import styled from "styled-components";
import theme from "@src/Tools/MuiTheme";

export const STButtonMargin = styled(Button)`
  && {
    margin: ${theme.spacing(1)}px;
  }
`;
